import { render, staticRenderFns } from "./LetsChatModal.vue?vue&type=template&id=dec3c93e&scoped=true&"
import script from "./LetsChatModal.vue?vue&type=script&lang=js&"
export * from "./LetsChatModal.vue?vue&type=script&lang=js&"
import style0 from "./LetsChatModal.vue?vue&type=style&index=0&id=dec3c93e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec3c93e",
  null
  
)

export default component.exports